import { render, staticRenderFns } from "./shandong-center.vue?vue&type=template&id=fe561142&scoped=true&"
import script from "./shandong-center.vue?vue&type=script&lang=js&"
export * from "./shandong-center.vue?vue&type=script&lang=js&"
import style0 from "./shandong-center.vue?vue&type=style&index=0&id=fe561142&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe561142",
  null
  
)

export default component.exports